import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  sub: string;
  exp: number;
  username: string;
  // Add other properties you need from the token
}

interface AuthState {
  accessToken: string | null;
  cognitoId: string | null;
  username: string | null;
  isTokenExpired: boolean;
}

const initialState: AuthState = {
  accessToken: null,
  cognitoId: null,
  username: null,
  isTokenExpired: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      try {
        const decodedToken: DecodedToken = jwtDecode(action.payload);
        state.cognitoId = decodedToken.sub;
        state.username = decodedToken.username;
        state.isTokenExpired = Date.now() >= decodedToken.exp * 1000;
      } catch (error) {
        console.error('Error decoding JWT token:', error);
        state.cognitoId = null;
        state.username = null;
        state.isTokenExpired = true;
      }
    },
    setDecodedToken: (state, action: PayloadAction<DecodedToken>) => {
      state.cognitoId = action.payload.sub;
      state.username = action.payload.username;
      state.isTokenExpired = Date.now() >= action.payload.exp * 1000;
    },
    clearAuth: (state) => {
      state.accessToken = null;
      state.cognitoId = null;
      state.username = null;
      state.isTokenExpired = false;
    },
    logout: () => {
      const isLocalhost = window.location.hostname === 'localhost';
      const options = isLocalhost
        ? 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=localhost'
        : 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.yuso.io;';

      document.cookie = `session=; ${options}`;
      document.cookie = `google_access_token=; ${options}`;
      document.cookie = `google_token_expires_in=; ${options}`;

      localStorage.removeItem('google_token_expires_in');
      sessionStorage.removeItem('referrer');

      window.location.href = isLocalhost ? 'http://localhost:3000' : import.meta.env.VITE_LOGIN;
    },
  },
});

export const { setAccessToken, setDecodedToken, clearAuth, logout } = authSlice.actions;
export default authSlice.reducer;
